import React from 'react';
import { ProsjektSammendragAvvistKommentar } from './ProsjektSammendragAvvistKommentar';
import { ProsjektSammendragError } from './ProsjektSammendragError';
import { ProsjektSammendragStepper } from './ProsjektSammendragStepper';
import { ProsjektSammendragTable } from './ProsjektSammendragTable';
import type { WithSubComponents } from '@forvalter/utils/TypeScriptUtils';
import { ProsjektSammendragProcessActions } from './ProsjektSammendragProcessActions';
import { ProsjektSammendragTitle } from './ProsjektSammendragTitle';
import { ProsjektSammendragNavigation } from './ProsjektSammendragNavigation';
import type { PropsWithChildren } from 'react';
import { ProsjektSammendragProvider } from './context/ProsjektSammendragProvider';
import { ProsjektSammendragProjectActions } from './ProsjektSammendragProjectActions';

type ProsjektSammendragSubComponents = {
    Navigation: typeof ProsjektSammendragNavigation;
    Title: typeof ProsjektSammendragTitle;
    Stepper: typeof ProsjektSammendragStepper;
    AvvistKommentar: typeof ProsjektSammendragAvvistKommentar;
    Table: typeof ProsjektSammendragTable;
    Error: typeof ProsjektSammendragError;
    ProcessActions: typeof ProsjektSammendragProcessActions;
    ProjectActions: typeof ProsjektSammendragProjectActions;
};

type ProsjektSammendragProps = {
    prosjektId: string;
    prosessInstansId: string;
};

export const ProsjektSammendrag: WithSubComponents<
    React.FC<PropsWithChildren<ProsjektSammendragProps>>,
    ProsjektSammendragSubComponents
> = ({ prosjektId, prosessInstansId, children }) => {
    return (
        <ProsjektSammendragProvider
            prosjektId={prosjektId}
            initialProcessId={prosessInstansId}
        >
            {children}
        </ProsjektSammendragProvider>
    );
};

ProsjektSammendrag.Navigation = ProsjektSammendragNavigation;
ProsjektSammendrag.Title = ProsjektSammendragTitle;
ProsjektSammendrag.Stepper = ProsjektSammendragStepper;
ProsjektSammendrag.AvvistKommentar = ProsjektSammendragAvvistKommentar;
ProsjektSammendrag.Table = ProsjektSammendragTable;
ProsjektSammendrag.Error = ProsjektSammendragError;
ProsjektSammendrag.ProcessActions = ProsjektSammendragProcessActions;
ProsjektSammendrag.ProjectActions = ProsjektSammendragProjectActions;
